'use client'

import { useEffect, useState } from 'react'
import { FaArrowUpLong } from 'react-icons/fa6'

const AppScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false)

  const handleScroll = () => {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop
    setIsVisible(scrollTop > 2000)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <button
      className={`opacity-50 hover:opacity-100 active:bg-grayscale-2 fixed bottom-5 right-5 bg-grayscale-5 text-white p-3 rounded flex items-center gap-3 ${
        isVisible ? 'block' : 'hidden'
      }`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <FaArrowUpLong />
      <span className="hidden md:block">Top</span>
    </button>
  )
}
export default AppScrollToTop
